/* Filters of the collection and search pages (snippets/collection-filters.liquid, styles in collection.css) and
   «Показати ще» under their grids.

   A tick, a size, a price inside a dropdown (desktop) or the sheet (phone) does not reload the page: the tiny
   sections/filter-count is rendered with the form's values (Section Rendering API) to read the product count, and
   every «Показати N товарів» button shows it. The button submits the form (a normal GET, so the URL stays shareable).
   Sort and the desktop «Тільки в наявності» switch apply at once.
   Desktop: one dropdown open at a time; a click outside closes it (the open summary covers the page, collection.css).
   Phone: «Фільтри» opens all filters as a full-screen sheet.
   «Показати ще» ([data-cf-more]) fetches the next page and appends its cards; with data-autoload on the page it
   does so by itself near the end of the grid. */
(() => {
  if (window.collectionFiltersReady) return;
  window.collectionFiltersReady = true;

  const SHEET = matchMedia('(max-width: 1023px)');
  const noun = (n) => {
    const m100 = n % 100;
    const m10 = n % 10;
    if (m100 >= 11 && m100 <= 14) return 'товарів';
    if (m10 === 1) return 'товар';
    if (m10 >= 2 && m10 <= 4) return 'товари';
    return 'товарів';
  };
  const query = (form) => {
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (v !== '') p.append(k, v);
    return p;
  };
  const submit = (form) => (form.requestSubmit ? form.requestSubmit() : form.submit());

  function initForm(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    const dropdowns = [...form.querySelectorAll('[data-cf-filter]')];
    const opener = form.querySelector('[data-cf-open]');
    let timer = 0;
    let token = 0;

    // empty price fields must not reach the URL as filter.v.price.gte=
    form.addEventListener('formdata', (e) => {
      for (const [k, v] of [...e.formData.entries()]) if (v === '') e.formData.delete(k);
    });

    async function recount() {
      const t = ++token;
      form.classList.add('is-counting');
      try {
        const html = await fetch(`${form.action}?${query(form)}&section_id=${form.dataset.section}`, { credentials: 'same-origin' }).then((r) => r.text());
        if (t !== token) return;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cf-count]');
        const n = el ? parseInt(el.dataset.cfCount, 10) : NaN;
        if (!Number.isNaN(n)) {
          form.querySelectorAll('[data-cf-apply]').forEach((b) => {
            b.textContent = n ? `Показати ${n} ${noun(n)}` : 'Нічого не знайдено';
            b.disabled = n === 0;
          });
        }
      } catch (err) { /* keep the previous number */ }
      if (t === token) form.classList.remove('is-counting');
    }
    const later = (ms) => { clearTimeout(timer); timer = setTimeout(recount, ms); };

    // the phone sheet shows the chosen values next to each filter name right away
    const summarize = (details) => {
      const sum = details && details.querySelector('.cf-f__sum');
      if (!sum) return;
      const names = [...details.querySelectorAll('input[type="checkbox"]:checked')].map((i) => {
        const label = i.closest('label');
        const t = label && label.querySelector('.cf-opt__t, span:not(.cf-opt__box):not(.cf-opt__n)');
        return t ? t.textContent.trim() : i.value;
      });
      const nums = [...details.querySelectorAll('input[type="number"]')].map((i) => i.value).filter(Boolean);
      sum.textContent = names.length ? names.join(', ') : nums.length ? nums.join(' – ') : '';
    };

    form.addEventListener('change', (e) => {
      const el = e.target;
      if (el.matches('[data-cf-find]')) return;
      if (el.matches('[data-cf-sort]')) { submit(form); return; }
      if (el.matches('[data-cf-avail]') && !SHEET.matches) { submit(form); return; }
      summarize(el.closest('[data-cf-filter]'));
      later(150);
    });
    form.addEventListener('input', (e) => {
      const el = e.target;
      if (el.matches('[data-cf-find]')) {
        const q = el.value.trim().toLowerCase();
        el.closest('.cf-f__panel').querySelectorAll('[data-cf-name]').forEach((li) => { li.hidden = !!q && !li.dataset.cfName.includes(q); });
        return;
      }
      if (el.type === 'number') later(500);
    });
    form.addEventListener('click', (e) => {
      const reset = e.target.closest('[data-cf-reset]');
      if (reset) {
        const panel = reset.closest('.cf-f__panel');
        panel.querySelectorAll('input[type="checkbox"]').forEach((i) => { i.checked = false; });
        panel.querySelectorAll('input[type="number"]').forEach((i) => { i.value = ''; });
        summarize(reset.closest('[data-cf-filter]'));
        recount();
        return;
      }
      if (e.target.closest('[data-cf-open]')) { openSheet(); return; }
      if (e.target.closest('[data-cf-close]')) closeSheet();
    });
    // the brand search field must not submit the form with Enter
    form.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('[data-cf-find]')) e.preventDefault(); });

    dropdowns.forEach((d) => d.addEventListener('toggle', () => {
      if (!d.open || SHEET.matches) return;
      dropdowns.forEach((o) => { if (o !== d) o.open = false; });
      const find = d.querySelector('[data-cf-find]');
      if (find) find.focus({ preventScroll: true });
    }));
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (form.classList.contains('is-sheet')) closeSheet();
      else dropdowns.forEach((d) => { d.open = false; });
    });

    function openSheet() {
      form.classList.add('is-sheet');
      document.documentElement.classList.add('cf-lock');
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }
    function closeSheet() {
      form.classList.remove('is-sheet');
      document.documentElement.classList.remove('cf-lock');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
    }
  }

  /* «Показати ще» */
  async function more(btn) {
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    btn.classList.add('is-loading');
    const scope = btn.closest('[data-cf-page]') || document;
    try {
      const html = await fetch(btn.href, { credentials: 'same-origin' }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = [...doc.querySelectorAll('[data-cf-grid] > li')];
      items.forEach((li, i) => { li.style.setProperty('--i', i % 12); li.classList.add('is-new'); });
      scope.querySelector('[data-cf-grid]').append(...items);
      const shown = doc.querySelector('[data-cf-shown]');
      const bar = doc.querySelector('[data-cf-progress]');
      if (shown) scope.querySelector('[data-cf-shown]').textContent = shown.textContent;
      if (bar) scope.querySelector('[data-cf-progress]').style.width = bar.style.width;
      const next = doc.querySelector('[data-cf-more]');
      if (next) btn.href = next.getAttribute('href');
      else btn.remove();
    } catch (err) {
      window.location.href = btn.href;
      return;
    }
    btn.classList.remove('is-loading');
    delete btn.dataset.busy;
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cf-more]');
    if (!btn || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    more(btn);
  });

  // type rail under the title (sections/t-collection): arrows + fades while there is more to either side,
  // the picked type scrolled into view
  function initRail(rail) {
    const list = rail.querySelector('.cp-chips');
    const btns = rail.querySelectorAll('[data-cp-rail-btn]');
    if (!list || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    const update = () => {
      const max = list.scrollWidth - list.clientWidth;
      const prev = list.scrollLeft > 2;
      const next = list.scrollLeft < max - 2;
      rail.classList.toggle('has-prev', prev);
      rail.classList.toggle('has-next', next);
      btns.forEach((b) => { b.hidden = b.dataset.cpRailBtn === '1' ? !next : !prev; });
    };
    btns.forEach((b) => b.addEventListener('click', () => {
      list.scrollBy({ left: Number(b.dataset.cpRailBtn) * list.clientWidth * 0.7, behavior: 'smooth' });
    }));
    const on = list.querySelector('.is-on');
    if (on) {
      const r = on.getBoundingClientRect();
      const lr = list.getBoundingClientRect();
      if (r.right > lr.right - 48) list.scrollLeft += r.left - lr.left - 48;
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-cf]').forEach(initForm);
    document.querySelectorAll('[data-cp-rail]').forEach(initRail);
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-cf-page][data-autoload]').forEach((scope) => {
      const row = scope.querySelector('[data-cf-more-row]');
      if (!row) return;
      new IntersectionObserver((entries) => entries.forEach((en) => {
        const btn = scope.querySelector('[data-cf-more]');
        if (en.isIntersecting && btn) more(btn);
      }), { rootMargin: '0px 0px 800px 0px' }).observe(row);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
